import styled from 'styled-components';
import { FlexibleTextPartial } from '@storefront/lib-global/partials/flexibleText';
import { RichTextPartial } from '@storefront/lib-global/partials/richText';
import { media, spacing } from '@storefront/lib-global/stylings';

export const FeatureContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FeatureContentHeader = styled(FlexibleTextPartial)`
  display: flex;
  justify-content: flex-start;
  margin: 0;

  @media ${media.greaterThan('lg')} {
    justify-content: center;
  }
`;

export const Content = styled.div`
  display: flex;
  margin-top: ${spacing.XS};

  @media ${media.greaterThan('lg')} {
    flex-direction: column;
    margin-top: 0;
    text-align: center;
  }
`;

export const FeatureContentImage = styled.span`
  align-items: flex-start;
  display: flex;
  justify-content: center;
  min-width: 71px;

  @media ${media.greaterThan('lg')} {
    align-items: center;
    height: 72px;
  }
`;

export const FeatureContentRichText = styled(RichTextPartial)`
  display: flex;
  justify-content: center;
  margin: 0;

  a {
    color: revert;
    text-decoration: underline;
  }
`;
